// Copyright (c) 2019 Shellyl_N and Authors
// license: ISC
// https://github.com/shellyln



export const boardStyle =
`/* per-board customized styles */
/*
.KanbanBoardView-sticky-note {width: 200px}
.KanbanBoardView-header-cell-task-statuses {min-width: 210px}
table.KanbanBoardView-board tbody th {
    padding: 10px;
    white-space: nowrap;
}
*/
table.KanbanBoardView-board thead th.status-todo {
    background-color: var(--weak-header-bg-color);
}
table.KanbanBoardView-board td.status-todo {
    background-color: var(--weak-data-bg-color);
}
table.KanbanBoardView-board thead th.status-done {
    background-color: var(--weak-header-bg-color);
}
table.KanbanBoardView-board td.status-done {
    background-color: var(--weak-data-bg-color);
}
.team-or-story-health .KanbanBoardView-sticky-note {
    background-color: var(--sticky-red-color);
}
.team-or-story-finance .KanbanBoardView-sticky-note {
    background-color: var(--sticky-pink-color);
}
.status-done .KanbanBoardView-sticky-note {
    background-color: var(--sticky-green-color);
}
.KanbanBoardView-sticky-tags .tag-bug {
    color: white;
    background-color: red;
}
.KanbanBoardView-sticky-tags .tag-ok {
    color: white;
    background-color: green;
}
.KanbanBoardView-sticky-tags .tag-NG {
    color: white;
    background-color: #e91e63;
}
.KanbanBoardView-sticky-tags .tag-PR {
    color: white;
    background-color: purple;
}
.KanbanBoardView-sticky-tags .tag-rejected {
    color: white;
    background-color: #990000;
}
.KanbanBoardView-sticky-tags .tag-pending {
    color: black;
    background-color: #ff9900;
}
.KanbanBoardView-sticky-tags .tag-merged {
    color: white;
    background-color: #006666;
}
.KanbanBoardView-sticky-tags .tag-critical {
    color: white;
    background-color: red;
}
.KanbanBoardView-sticky-tags .tag-high {
    color: white;
    background-color: #ff5522;
}
.KanbanBoardView-sticky-tags .tag-moderate {
    color: black;
    background-color: #ffcc00;
}
.KanbanBoardView-sticky-tags .tag-low {
    color: black;
    background-color: #cc9900;
}
.KanbanBoardView-sticky-tags .tag-star {
    color: inherit;
    background-color: inherit;
}
`;

export const calendarStyle =
`/* per-board customized styles */
  div.CalendarView-item-chip.status-done {
      background-color: var(--sticky-green-color);
  }
`;


export const boardNote =
`# This is a board note.
* Markdown syntax is available.
* Go [Editor](#/edit/) to edit this note.`;


export const initialData = {
    "boards": [{
        "type": "kanbanBoard",
        "name": "Personal",
        "taskStatuses": [{
            "value": "Todo",
            "caption": "Todo",
            "className": "status-todo"
        }, {
            "value": "Wait",
            "caption": "Wait",
            "className": "status-wait"
        }, {
            "value": "Plan",
            "caption": "Plan",
            "className": "status-plan"
        }, {
            "value": "Next",
            "caption": "Next",
            "className": "status-next",
        }, {
            "value": "Doing",
            "caption": "Doing",
            "className": "status-doing"
        }, {
            "value": "Cancelled",
            "caption": "Cancelled",
            "className": "status-cancelled"
        }, {
            "value": "Done",
            "caption": "Done",
            "className": "status-done",
            "completed": true
        }],
        "teamOrStories": [{
            "value": "Health",
            "caption": "Health",
            "className": "team-or-story-health"
        }, {
            "value": "Finance",
            "caption": "Finance",
            "className": "team-or-story-finance"
        }, {
            "value": "Human",
            "caption": "Human",
            "className": "team-or-story-human"
        }, {
            "value": "Project",
            "caption": "Project",
            "className": "team-or-story-project"
        }],
        "tags": [{
            "value": "bug",
            "className": "tag-bug"
        }, {
            "value": "ok",
            "className": "tag-ok"
        }, {
            "value": "NG",
            "className": "tag-NG"
        }, {
            "value": "PR",
            "className": "tag-PR"
        }, {
            "value": "rejected",
            "className": "tag-rejected"
        }, {
            "value": "pending",
            "className": "tag-pending"
        }, {
            "value": "merged",
            "className": "tag-merged"
        }, {
            "value": "critical",
            "className": "tag-critical"
        }, {
            "value": "high",
            "className": "tag-high"
        }, {
            "value": "moderate",
            "className": "tag-moderate"
        }, {
            "value": "low",
            "className": "tag-low"
        }, {
            "value": "⭐",
            "className": "tag-star"
        }, {
            "value": "⭐⭐",
            "className": "tag-star"
        }, {
            "value": "⭐⭐⭐",
            "className": "tag-star"
        }],
        "displayBarcode": true,
        "displayMemo": true,
        "displayFlags": true,
        "displayTags": true,
        "preferArchive": false,
        "boardStyle": boardStyle,
        "calendarStyle": calendarStyle,
        "boardNote": "",
    }],
    "records": [{
      "type": "kanban",
        "dueDate": '2021-12-31',
        "description":
            "# COVID Vaccine \n\n" +
            "First Jab",
        "barcode": "",
        "memo": "",
        "flags": [],
        "tags": [],
        "boardId": "",
        "teamOrStory": "Health",
        "taskStatus": "Todo"
    }, {
        "type": "kanban",
        "dueDate": '2021-12-31',
        "description":
            "# COVID Vaccine \n\n" +
            "Second Jab",
        "barcode": "",
        "memo": "",
        "flags": [],
        "tags": [],
        "boardId": "",
        "teamOrStory": "Health",
        "taskStatus": "Todo"
    },  {
        "type": "kanban",
        "dueDate": '2021-10-31',
        "description":
            "# Tax Return \n\n" +
            "Do Yourself",
        "barcode": "",
        "memo": "",
        "flags": [],
        "tags": [],
        "boardId": "",
        "teamOrStory": "Finance",
        "taskStatus": "Todo"
    },  {
        "type": "kanban",
        "dueDate": '2022-05-15',
        "description":
            "# Tax Return \n\n" +
            "Through Accountant",
        "barcode": "",
        "memo": "",
        "flags": [],
        "tags": [],
        "boardId": "",
        "teamOrStory": "Finance",
        "taskStatus": "Todo"
    }]
}
